import { Locale } from '../typings';
import { en_US } from './en_US.locale';
import { es_US } from './es_US.locale';
import { fr_CA } from './fr_CA.locale';
import { fr_FR } from './fr_FR.locale';

export const locales: { [key: string]: Locale } = {
  en_US,
  es_US,
  fr_CA,
  fr_FR,
};
